import { handleAuthenticationFailure } from '../tools/AuthSession';

export const BUILDING_API_URL = "https://us-central1-elevatortvbackend.cloudfunctions.net/building-api-backend";

export async function buildingApi(action, options = {}) {
  const url = new URL(BUILDING_API_URL);
  url.searchParams.set("action", action);
  Object.entries(options.query || {}).forEach(([key, value]) => url.searchParams.set(key, value));
  const fetchOptions = { ...options };
  delete fetchOptions.query;
  const response = await fetch(url.toString(), {
    ...fetchOptions,
    headers: {
      user_id: localStorage.getItem("etv.user_id") || "",
      access_token: localStorage.getItem("etv.access_token") || "",
      ...(fetchOptions.body ? { "Content-Type": "application/json" } : {}),
      ...(fetchOptions.headers || {}),
    },
  });
  const data = await response.json();
  handleAuthenticationFailure(response, data);
  if (!response.ok || !data.result) throw new Error(data.error || `http_${response.status}`);
  return data;
}
